import(/* webpackMode: "eager" */ "/app/src/app/proyectos/page.tsx");
